module.exports = __webpack_public_path__ + "static/media/ἔρχομαι_2nd_aorist_active_ind_img.4a88dd66.JPG";